import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { AccessControlService } from 'src/app/services/access-control.service';
declare var $: any;
@Component({
  selector: 'app-side-nav-bar',
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.css']
})

export class SideNavBarComponent implements OnInit{
  menuType: any;
  isCourse: boolean = false;
  currentUrl: any = '';
  app_id: any;
  tenant:any
  isTenant:boolean=false;
constructor(public authService: AuthService,
    private accessControlService: AccessControlService,
    private router: Router) {
    this.currentUrl = this.router.url
    this.tenant=localStorage.getItem("org_name");

  }

  ngOnInit() {
    this.menuType = false;localStorage.getItem('option');
    this.app_id = localStorage.getItem('org_id');
    this.isTenant=localStorage.getItem('type')=="1"?true:false;

  }
  activeRoute(routename: string): boolean{
    return this.router.url.indexOf(routename) > -1;
  }
  ngAfterViewInit() {
    (<any>jQuery('#side-menu')).metisMenu();

    if (jQuery("body").hasClass('fixed-sidebar')) {
      (<any>jQuery('.sidebar-collapse')).slimscroll({
        height: '100%'
      })
    }
  }

}
